export const excelInterfacesServiceQueryKeys = {
  exportLotXLSX: 'exportLotXLSX',
  exportCriteria: 'exportCriteria',
  getFileHandlingStatus: 'getFileHandlingStatus',
} as const;
